import {initTileViewBtn} from './tileView';
import {handleMobileViewMenu} from './view/handleView';
import {closeAllFilters} from './view/mobileView';
import {handleOptSelect} from './view/desktopView'
import {mobileMaxWidth} from "../../../_common/breakPoints";
/**
 * initialize event listener for quantity modifier button
 */
export const plpViewMenu = (function () {
  'use strict';

  const bpMax01 = mobileMaxWidth;
  const init = function () {
    // do sanity check if the plp view menu is there or not
    const plpViewMenu = document.getElementById("plp-view-menu");
    if (plpViewMenu === null || plpViewMenu === undefined) {
      return;
    }

    bpMax01.addListener(handleMobileViewMenu.bind(bpMax01));
    handleMobileViewMenu.call(bpMax01);
    // add close button
    const menuClose = document.querySelector(".view-menu__top-close-js");

    if (menuClose.length !== 0 && menuClose !== null) {
      menuClose.onclick = closeAllFilters.bind(null, bpMax01);
    }

    const closeButton = document.getElementById("mobile-filter-apply-btn");
    if (closeButton) {
      closeButton.onclick = closeAllFilters.bind(null, bpMax01);
    }

    initHandleOpts(plpViewMenu);
    initTileViewBtn();
  };

  /**
   * init the handle options event listener in product listing view menu
   * @param {*} el
   */
  const initHandleOpts = function(el) {
    const opts = el.querySelectorAll(".view-menu__opt");
    opts.forEach(opt => {
      opt.parentElement.onclick = handleOptSelect.bind(bpMax01);
    })
  };

  return {
    init: init
  };


});


// WEBPACK FOOTER //
// ./javascript/product-search-page/raw-from-relab/plp-header/index.js